'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.backLink = exports.journeyHandler = exports.default = undefined;

var _journeyHandler = require('./journeyHandler');

var _journeyHandler2 = _interopRequireDefault(_journeyHandler);

var _rpGuiGuide = require('rp-gui-guide');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _backLink = require('./backLink');

var _backLink2 = _interopRequireDefault(_backLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var popup = function popup() {
    var linkSelector = '.js-popupLink';
    var $body = (0, _jquery2.default)('body');
    var defaultOptions = 'resizable=yes, scrollbars=yes, fullscreen=no, channelmode=no,';

    function openPopup(event) {
        event.preventDefault();

        var $currentTarget = (0, _jquery2.default)(event.currentTarget);
        var href = $currentTarget.attr('href');

        if (_rpGuiGuide.mobileDetect.mobile()) {
            var blankPage = $currentTarget.attr('data-popup-blank') !== undefined;
            var validHref = href.indexOf('#') !== -1 ? href.substring(0, href.indexOf('#')) : href;
            _journeyHandler2.default.trackJourney(validHref);

            if (blankPage) {
                window.open(href, '_blank');
            } else {
                window.open(href, '_self');
            }
        } else {
            var width = $currentTarget.attr('data-popup-width') || 750;
            var height = $currentTarget.attr('data-popup-height') || 800;
            var params = defaultOptions + ' width=' + width + ', height=' + height;

            var winRef = window.open(href, '', params);

            winRef.onload = function () {
                if (winRef.outerHeight > winRef.screen.availHeight) {
                    winRef.resizeTo(winRef.outerWidth, winRef.screen.availHeight);
                }
            };
        }
    }

    $body.on('click', linkSelector, openPopup);
};

exports.default = popup;
exports.journeyHandler = _journeyHandler2.default;
exports.backLink = _backLink2.default;


//////////////////
// WEBPACK FOOTER
// ./~/rp-popup/lib/popup.js
// module id = 236
// module chunks = 1